// extracted by mini-css-extract-plugin
export default {"circlesWrapper":"DynamicBackground_circlesWrapper__rUMvj","circle":"DynamicBackground_circle__Ndjq9"};